function parseDateOnly(value) {
  if (!value) return null;
  const raw = String(value).slice(0, 10);
  if (!/^\d{4}-\d{2}-\d{2}$/.test(raw)) return null;
  const [year, month, day] = raw.split('-').map(Number);
  const dt = new Date(year, (month || 1) - 1, day || 1);
  if (Number.isNaN(dt.getTime())) return null;
  dt.setHours(0, 0, 0, 0);
  return dt;
}

export function isActiveCrmTraderToday(row, now = new Date()) {
  if (!row?.active) return false;
  const today = new Date(now);
  today.setHours(0, 0, 0, 0);
  const startedAt = parseDateOnly(row?.started_at);
  const endedAt = parseDateOnly(row?.ended_at);
  if (startedAt && today < startedAt) return false;
  if (endedAt && today > endedAt) return false;
  return Number(row?.user_id || 0) > 0;
}

export function activeCrmTraderUserIds(crmTraders = []) {
  return new Set(
    (Array.isArray(crmTraders) ? crmTraders : [])
      .filter((row) => isActiveCrmTraderToday(row))
      .map((row) => Number(row.user_id))
      .filter((id) => id > 0)
  );
}

export function activeCrmTraderUsers(crmTraders = [], users = [], extraUserIds = []) {
  const ids = activeCrmTraderUserIds(crmTraders);
  (Array.isArray(extraUserIds) ? extraUserIds : []).forEach((id) => {
    const n = Number(id);
    if (n > 0) ids.add(n);
  });

  const byId = new Map();
  (Array.isArray(users) ? users : []).forEach((u) => {
    const id = Number(u?.id || 0);
    if (id > 0) byId.set(id, u);
  });
  (Array.isArray(crmTraders) ? crmTraders : []).forEach((row) => {
    const id = Number(row?.user_id || 0);
    if (id > 0 && row?.user && !byId.has(id)) byId.set(id, row.user);
  });

  return Array.from(ids)
    .map((id) => byId.get(id) || { id, username: `ID ${id}` })
    .sort((a, b) => {
      const an = String(a?.employee?.name || a?.username || a?.id || '');
      const bn = String(b?.employee?.name || b?.username || b?.id || '');
      return an.localeCompare(bn);
    });
}
